<template>
	<div id="ListShippingSubscriptionComponent">
		<vue-snotify></vue-snotify>
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromOrders" @change="getAllShippingSubscriptionsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToOrders" @change="getAllShippingSubscriptionsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchShippingSubscriptions"
					v-model="searchOrders"
					v-on:keyup.enter="getAllShippingSubscriptionsLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllShippingSubscriptionsLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<div class="form-group form-check">
					<input type="checkbox" class="form-check-input" id="printInvoicesCheck" v-model="printInvoices">
					<label class="form-check-label" for="printInvoicesCheck">Incluir Boleta</label>
				</div>
				<div class="float-right d-none d-sm-inline separator"></div>
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsOrder" @change="changeQRowsOrder">
					<option>5</option>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>
		<table class="table table-sm table-12 table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Campo</th>
					<th class="text-center">Iglesia</th>
					<th class="text-center">Enviar a</th>
					<th class="text-center">Dirección</th>
					<th class="text-center">Transporte</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listOrders" :key="index">
					<td class="text-center">{{item.id}}</td>
					<td>{{item.church.entity.synthetic}}</td>
					<td>{{item.church.type_church.name}} {{item.church.name}}</td>
					<td>{{item.client.name}} {{item.client.surname}}</td>
					<td>
						<span v-if="item.address != null">{{item.address.street}} - {{item.address.comuna}}</span></td>
					<td class="text-center">
						<span class="badge" :class="'badge-' + item.address.transport.color" v-if="item.address != null">{{item.address.transport.name}}</span>
					</td>
					<td>
						<i class="fas fa-file-invoice margin-right5"
							:class="(existOrderLegalDocument(item.order_legal_documents) == -1) ? 'text-black-50' : (existOrderLegalDocument(item.order_legal_documents) == 0) ? 'text-info' : 'text-success pointer'"
							:title="(existOrderLegalDocument(item.order_legal_documents) == -1) ? 'Sin Documento Adjunto' : (existOrderLegalDocument(item.order_legal_documents) == 0) ? 'Documento sin firmar' : 'Documento Firmado Nº' + existOrderLegalDocument(item.order_legal_documents)"
							@click="toPrintFacturacionCLLocal(52, existOrderLegalDocument(item.order_legal_documents), item.church.type_church.name + ' ' + item.church.name)">
						</i>
						<i class="fas fa-ticket-alt pointer text-info margin-right5" @click="toPrintLabelLocal(item)"></i>
						<i class="fas fa-print pointer" @click="printerAll(item)" :class="(generateAll) ? 'text-black-50' : ''"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationOrders" @getAllList="getAllShippingSubscriptionsLocal"></pagination>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import orders from '@/mixins/orders'
import legalDocuments from '@/mixins/legalDocuments'
import shippingsRequest from '@/mixins/shippingsRequest'
import subscription from '@/mixins/subscription'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import webSocketServer from '@/mixins/webSocketServer.js'
import label from "@/mixins/labels/"

import Pagination from '@/components/Pagination.vue'

export default {
	name: 'ListShippingSubscriptionComponent',
	mixins: [axiosAction, errors, mixin, orders, legalDocuments, shippingsRequest, subscription, facturacionCLPrint, webSocketServer, label],
	data () {
		return {
			generateAll: false,
			orderSelected: null,
			printInvoices: false
		}
	},
	components: {
		'pagination': Pagination,
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.connectFacturacionCLPrint()
			this.connectWebSocketServer()
			this.setOrderInit()
			this.showLabel(2)
		},
        changeQRowsOrderLocal() {
            this.getAllShippingSubscriptionsLocal()
        },
		existOrderLegalDocument(legalDocument) {
			let index = legalDocument.map((el) => parseInt(el.type_legal_document_id)).indexOf(52)
			if(index > -1)
				return legalDocument[index].legal_document_number
			return index
		},
		existOrderShippingRequest(shippingRequest) {
			if(shippingRequest.length == 1) {
				return shippingRequest[0].id
			}
			return -1
		},
		getAllOrdersResultLocal(response) {},
		getAllShippingSubscriptionsLocal(page = 1) {
			this.getAllOrdersByShippingSubscription(page)
		},
		getInvoiceShippingSubscriptionResult(response) {
			if(response.data.success == true) {
				response.data.data.forEach(legalDocument => {
					this.toPrintFacturacionCLLocal(legalDocument.type_legal_document_id, legalDocument.legal_document_number, legalDocument.contact)
				});
			}
		},
		getSubscriptionDetailResultLocal(response) {
			if(response.data.success == true) {
				response.data.data.forEach(el => {
					this.sleep(1000)
					this.printOrderDetail(el)
				})
				if(this.orderSelected.order_legal_documents != null) {
					let index = this.orderSelected.order_legal_documents.map((el) => parseInt(el.type_legal_document_id)).indexOf(52)
					if(index > -1) {
						this.toPrintFacturacionCLLocal(this.orderSelected.order_legal_documents[index].type_legal_document_id, this.orderSelected.order_legal_documents[index].legal_document_number, this.orderSelected.church.type_church.name + ' ' + this.orderSelected.church.name)
					}
				}
			}
			if(this.printInvoices) {
				this.getInvoiceShippingSubscription(this.orderSelected.id)
			}
			this.generateAll = false
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				case 'getInvoiceShippingSubscriptionResult': this.getInvoiceShippingSubscriptionResult(response); break;
				case 'getSubscriptionDetailResult': this.getSubscriptionDetailResult(response); break;
				case 'saveOrderShippingRequestResult': this.saveOrderShippingRequestResult(response); break;
				case 'saveShippingRequestResult': this.saveShippingRequestResult(response); break;
				case 'resultShowLabelGET': this.resultShowLabelGET(response); break;
				case 'sendToRegulatoryEntityResult': this.sendToRegulatoryEntityResult(response); break;
				case 'storeLegalDocumentForShippingSubscriptionResult': this.storeLegalDocumentForShippingSubscriptionResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveShippingRequestResult(response) {
			if(response.data.success == true) {
				let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(this.orderSelected.id))
				if(index > -1) {
					this.listOrders[index].order_shipping_request.push(response.data.data)
					this.orderSelected = this.listOrders[index]
				} 
				this.saveOrderShippingRequest(this.orderSelected.id, response.data.data.id)
			}
		},
		saveOrderShippingRequestResultLocal(response) {
			this.printerShippingRequest(this.orderSelected)
		},
		saveShippingRequestLocal() {
			this.notConsider = true
			this.saveShippingRequest()
		},
		setRecipientDataLocal(item) {
			this.orderSelected = item
			if(this.existOrderShippingRequest(this.orderSelected.order_shipping_request) == -1) {
				this.clearObjectShippingRequest()
				let sendto = item.client.name + ' ' + item.client.surname
				let number_document = item.client.number_document
				let email = item.client.email
				let address = item.address.street
				let comuna = item.address.comuna
				let phone = item.client.phone
				let paidShipping = 1
				let transportId = item.address.transport_id
				let transport = item.address.transport.name
				this.objectShippingRequest.commentary = 'G' + this.existOrderLegalDocument(item.order_legal_documents) + ' - SUSC: ' + item.church.type_church.name + ' ' + item.church.name
				this.objectShippingRequest.totalPrice = item.total
				this.setRecipientData(sendto, number_document, email, address, comuna, phone, paidShipping, transportId, transport)
				this.objectShippingRequest.notConsider = true
				this.saveShippingRequestLocal()
			} else {
				this.printerShippingRequest(this.orderSelected)
			}
		},
		printerAll(item) {
			if(!this.generateAll) {
				this.generateAll = true
				this.orderSelected = item
				let index = this.orderSelected.order_legal_documents.map((el) => parseInt(el.type_legal_document_id)).indexOf(52)
				if(index > -1) {
					if(this.orderSelected.order_legal_documents[index].legal_document_number == 0) {
						this.sendToRegulatoryEntityLocal(this.orderSelected.order_legal_documents[index].id)
					} else {
						this.setRecipientDataLocal(this.orderSelected)
					}
				} else {
					this.storeLegalDocumentForShippingSubscriptionLocal(this.orderSelected.id)
				}
			}
		},
		printerShippingRequest(item) {
			this.orderSelected = item
			this.getSubscriptionDetail(this.orderSelected.id)
		},
		sendToRegulatoryEntityLocal(id) {
			this.sendToRegulatoryEntity(id)
		},
		sendToRegulatoryEntityResultLocal(response) {
			if(response.data.success == true) {
				let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(this.orderSelected.id))
				if(index > -1) {
					let ind = this.listOrders[index].order_legal_documents.map((el) => parseInt(el.id)).indexOf(parseInt(response.data.data.id))
					if(ind > -1) {
						this.listOrders[index].order_legal_documents[ind].legal_document_number = response.data.data.legal_document_number
					}
					this.orderSelected = this.listOrders[index]
					this.setRecipientDataLocal(this.orderSelected)
				}
			}
		},
		storeLegalDocumentForShippingSubscriptionLocal(id) {
			this.storeLegalDocumentForShippingSubscription(id)
		},
		storeLegalDocumentForShippingSubscriptionResultLocal(response) {
			if(response.data.success == true) {
				let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(this.orderSelected.id))
				if(index > -1) {
					this.listOrders[index].order_legal_documents.push(response.data.data)
					this.sendToRegulatoryEntityLocal(response.data.data.id)
				} 
			}
		},
		toPrintFacturacionCLLocal(typeLegalDocumentId, legalDocumentNumber, head = '') {
			if(legalDocumentNumber > 0) {
				this.toPrintFacturacionCL(typeLegalDocumentId, legalDocumentNumber, head)
			}
		},
		toPrintLabelLocal(item) {
			if(this.existOrderShippingRequest(item.order_shipping_request)) {
				if(item.client.number_document == null || item.client.number_document == '') {
					this.$snotify.warning('El cliente "' + item.client.name + ' ' + item.client.surname + '" no tiene RUT registrado', 'SIN RUT')
				}
				if(item.client.email == null || item.client.email == '') {
					this.$snotify.warning('El cliente "' + item.client.name + ' ' + item.client.surname + '" no tiene EMAIL registrado', 'SIN EMAIL')
				}
				let arrayZPL = []
				let street = (item.address != null) ? item.address.street : '';
				let comuna = (item.address != null) ? item.address.comuna : '';
				let img_zpl = (item.address != null) ? item.address.transport.img_zpl : null;
				let phone = (item.client.phone != null) ? item.client.phone : '';
				arrayZPL.push({'name': 'sendto' , 'value': this.cleanedStringZPL(item.client.name + ' ' + item.client.surname).toUpperCase()})
				arrayZPL.push({'name': 'number_document' , 'value': item.client.number_document})
				arrayZPL.push({'name': 'email' , 'value': item.client.email})
				arrayZPL.push({'name': 'address' , 'value': this.cleanedStringZPL(street).toUpperCase()})
				arrayZPL.push({'name': 'comuna' , 'value': this.cleanedStringZPL(comuna).toUpperCase()})
				arrayZPL.push({'name': 'phone' , 'value': this.cleanedStringZPL(phone).toUpperCase()})
				arrayZPL.push({'name': 'img_zpl' , 'value': (img_zpl != null) ?  img_zpl : item.address.transport.name})
				arrayZPL.push({'name': 'paid_shipping_desc' , 'value': 'CTACTE'})
				arrayZPL.push({'name': 'clicod' , 'value': 'NDOC ' + this.existOrderLegalDocument(item.order_legal_documents)})
				arrayZPL.push({'name': 'cliente' , 'value': item.church.type_church.name + ' ' + item.church.name})
				arrayZPL.push({'name': 'codbareti' , 'value': item.order_shipping_request[0].barcode + '0001'})
				arrayZPL.push({'name': 'campomisdesc' , 'value': item.church.entity.synthetic  })
				arrayZPL.push({'name': 'total_price' , 'value': item.total })
				this.replaceZPLVariableFromArray(arrayZPL)
				this.toPrintWithVariables()
			}
		},
	},
	mounted () {
		this.initModule()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
